const GAME_KEY = process.env.REACT_APP_GAME_NAME ?? "quiz";
const QUIZ_DATA_KEY = "quiz_data";
const TIME_REMAINING = "time_remaining";
const CHATS_KEY = "chats";
const AUDIO_DEVICE = "audio_device";
const USER_KEY = "user";
const ORG_KEY = "org";
const GAMEPLAY_ID = "linkId";
const PARENT_APP = "parent_app";
const FREE_TEXT_CACHE = "ft_cache" // Cache object for Free text rich editor periodic saves

const setItem = (key, data) => localStorage.setItem(key, JSON.stringify(data));

const getItem = (key) => JSON.parse(localStorage.getItem(key));

const removeItem = (key) => localStorage.removeItem(key);

const setSessionItem = (key, data) => sessionStorage.setItem(key, JSON.stringify(data));

const getSessionItem = (key) => JSON.parse(sessionStorage.getItem(key));

const set = {
  gameId: (id) => setItem(GAME_KEY, id),
  quizData: (data) => setItem(QUIZ_DATA_KEY, data),
  timeRemaining: (time) => setItem(TIME_REMAINING, time),
  chats: (data) => setItem(CHATS_KEY, data),
  audioDevice: (data) => setItem(AUDIO_DEVICE, data),
  user: (data) => setItem(USER_KEY, data),
  org: (data) => setItem(ORG_KEY, data),
  gameplayId: (data) => setItem(GAMEPLAY_ID, data),
  parentApp: (data) => setSessionItem(PARENT_APP, data),
  freeTextCache: (data) => setItem(FREE_TEXT_CACHE, data)
};

const get = {
  gameId: () => getItem(GAME_KEY),
  quizData: () => getItem(QUIZ_DATA_KEY),
  timeRemaining: () => getItem(TIME_REMAINING),
  chats: () => getItem(CHATS_KEY),
  audioDevice: () => getItem(AUDIO_DEVICE),
  user: () => getItem(USER_KEY),
  org: () => getItem(ORG_KEY),
  gameplayId: () => getItem(GAMEPLAY_ID),
  parentApp: () => getSessionItem(PARENT_APP),
  freeTextCache: () => getItem(FREE_TEXT_CACHE)
};

const destroy = {
  all: () => localStorage.clear(),
  allExceptTimeRemaining: () => {
    const timeRemaining = get.timeRemaining()
    const freeTextCache = get.freeTextCache()
    // Temp -> Add FreeTextCache to save list as well here
    localStorage.clear()
    sessionStorage.clear()
    set.timeRemaining(timeRemaining)
    set.freeTextCache(freeTextCache)
  },
  gameId: () => removeItem(GAME_KEY),
  quizData: () => removeItem(QUIZ_DATA_KEY),
  chats: () => removeItem(CHATS_KEY),
  audioDevice: () => removeItem(AUDIO_DEVICE),
  timeRemaining: () => removeItem(TIME_REMAINING),
  freeTextCache: () => removeItem(FREE_TEXT_CACHE),
};

export const storage = {
  set,
  get,
  destroy,
};
